module.exports = __webpack_public_path__ + "img/graphics-11.af08cfb6.svg";